import React, { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import { WebshopColorsModel } from '../models/WebshopColorModel';
import { getWebshopColors } from '../services/WebshopColorService';

interface ColorContextInterface {
  buttonColor: string;
  buttonTextColor: string;
  primaryColor: string;
}

const ColorContext = React.createContext<ColorContextInterface>({} as ColorContextInterface);

export const ColorContextProvider = ({ children }: { children: JSX.Element }) => {
  const [buttonColor, setButtonColor] = useState<string>('#000000');
  const [buttonTextColor, setButtonTextColor] = useState<string>('#ffffff');
  const [primaryColor, setPrimaryColor] = useState<string>('#ffffff');

  useAsyncEffect(async () => {
    const webshopColors = (await getWebshopColors()) as WebshopColorsModel;

    const buttonColor = webshopColors.primaryButtonColor ?? '#000000';
    const buttonTextColor = webshopColors.primaryButtonTextColor ?? '#ffffff';
    const primaryColor = webshopColors.primaryColor ?? '#ffffff';

    setButtonColor(buttonColor);
    setButtonTextColor(buttonTextColor);
    setPrimaryColor(primaryColor);
  }, []);

  return <ColorContext.Provider value={{ buttonColor, buttonTextColor, primaryColor }}>{children}</ColorContext.Provider>;
};

/**
 * Use method
 * @returns
 */
export const useColorContext = () => {
  const context = React.useContext(ColorContext);

  if (context === undefined) {
    throw new Error('use must be used within a Provider');
  }

  return context;
};
